'use client';

import * as React from 'react';

import { EventBus } from '@/shared/utils';
import { Box, Typography } from '@mui/material';
import EducationalPathDetail from './educational-path-detail';
import { useSeriesByIdStore } from '../../store/series-by-id-store';
import { SeriesByIdEventKeys, SeriesByIdEvents } from '../../events';
import { useAuthStore } from '@/auth';
import { SkilllevelsType } from 'src/shared/types/course';
import ProgressBar from './progress-bar';
import DetailsSummarySkeleton from 'src/shared/components/loading-skeleton/details-summary';

const SummaryDetails: React.FC<{
  seriesDocumentId: string;
  eventBus: EventBus<SeriesByIdEvents>;
  isSubscriber: boolean;
}> = ({ seriesDocumentId, eventBus, isSubscriber }) => {
  const { summaryDetails, customerSubscription } = useSeriesByIdStore();
  const { user } = useAuthStore();

  React.useEffect(() => {
    if (!summaryDetails?.data)
      eventBus.emit(SeriesByIdEventKeys.summary.view, { seriesDocumentId });
  }, [summaryDetails?.data, eventBus]);

  if (summaryDetails.status.isLoading || !summaryDetails?.data) return <DetailsSummarySkeleton />;
  return (
    <>
      <Box
        mb={2}
        className="flex flex-col items-start gap-y-2 md:flex-row gap-x-3 md:justify-between md:items-center"
      >
        <Typography variant="h1" component="h1">
          {summaryDetails.data?.title}
        </Typography>
        {isSubscriber && <ProgressBar />}
      </Box>
      <EducationalPathDetail
        requirements=""
        eventBus={eventBus}
        seriesDocumentId={seriesDocumentId}
        customerOwnsSeries={
          !!customerSubscription?.data?.purchasedSeries?.find(
            (s) => s?.documentId === seriesDocumentId,
          )?.documentId
        }
        thumbnail={summaryDetails.data?.thumbnail?.url || ''}
        description={summaryDetails.data?.description || ''}
        stripeLink={summaryDetails.data?.stripeLink || ''}
        userEmail={user?.email || ''}
        userUid={user?.uid || ''}
        isSubscriber={isSubscriber}
        instructors={
          summaryDetails.data?.teacherProfiles?.map((el) => ({
            name: el.displayName || '',
            avatarUrl: el.profilePicture?.url || '',
            profession: el.mainSubject || '',
            artistsWorkedwith: el.artistsWorkedWith,
          })) || []
        }
        lessonCount={summaryDetails.data?.numberOfVideos || 0}
        level={
          (summaryDetails.data?.skillLevel?.name?.toLowerCase() as SkilllevelsType) || undefined
        }
        title={summaryDetails.data?.title || ''}
      />
    </>
  );
};

export { SummaryDetails };
